import React, {useEffect, useMemo, useState} from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import Collapse from '@mui/material/Collapse';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import FormHelperText from '@mui/material/FormHelperText';

// import {getFormErrors} from 'ultra/helpers/content';

import {useFormStore} from '../../../Stores/form';

import './index.scss';

export default function Password(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors, clearFormError} = useFormStore();
    // setFormError

    const [error, setError] = React.useState();

    const [password, setPassword] = React.useState(content[field.id] || "");
    const [passwordDublicate, setPasswordDublicate] = React.useState("");

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const className = useMemo(() => {
        let result = "PasswordField";
        result += isDisabled ? ' disabled' : ''
        result += error ? ' error' : ''
        return result;
    }, [isDisabled, error])

    useEffect(() => {
        if (!password && formVisibleErrors?.[field.id]) {
            setError(formVisibleErrors[field.id]);
        }
    }, [formVisibleErrors?.[field.id]])

    const [duplicateFieldChanged, setDuplicateFieldChanged] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event) => { event.preventDefault(); };

    // CHANGE
    const onPasswordControlChangeHandler = (e) => {
        setPassword(e?.target?.value || "");
        if (!e?.target?.value) {
            setPasswordDublicate("");
            setDuplicateFieldChanged(false);
        }

        clearFormError(field.id);
        setError(null);

        const err = getErrors(e?.target?.value, passwordDublicate);
        if (!hasEmpty(e?.target?.value, passwordDublicate) && !err) onChange(e);
        else onChange({target: {value: ""}});
    }

    const onPasswordDublicateControlChangeHandler = (e) => {
        setPasswordDublicate(e?.target?.value || "");
        if (!e?.target?.value) setDuplicateFieldChanged(false);

        clearFormError(field.id);
        setError(null);

        const err = getErrors(password, e?.target?.value);
        if (!hasEmpty(password, e?.target?.value) && !err) onChange(e);
        else onChange({target: {value: ""}});
    }

    // BLUR
    const onBlurHandler = (e) => {
        onBlur(e);

        // TODO: fix issue:
            // if first field was changed but next focus goes not
            // to second field, when "is required not works"
        // // when only first value was chsnged, global content not changed, so
        // // separate validation needed here
        // if (hasEmpty(e?.target?.value, passwordDublicate) && !formVisibleErrors?.[field.id]) {
        //     setFormError(field.id, "Поле обовязкове для заповнення")
        // }

        // set error
        if (!duplicateFieldChanged || hasEmpty(e?.target?.value, passwordDublicate)) {
            if (formVisibleErrors?.[field.id]) setError(formVisibleErrors?.[field.id]);
            return false;
        }
        else {
            const err = formVisibleErrors?.[field.id] || getErrors(e?.target?.value, passwordDublicate);
            if (err) setError(err);
            else if (error) setError(null);
        }
    }

    const onPasswordDublicateControlBlurHandler= (e) => {
        setDuplicateFieldChanged(true);

        onBlur(e);

        if (hasEmpty(password, e?.target?.value)) {
            if (formVisibleErrors?.[field.id]) setError(formVisibleErrors?.[field.id]);
            return false;
        }
        else {
            const err = formVisibleErrors?.[field.id] || getErrors(password, e?.target?.value);
            if (err) setError(err);
            else if (error) setError(null);
        }
    }

    if (isEditMode) return null;

    return <div className={className}>
        <FormControl fullWidth required={field.required} variant="outlined">
            <InputLabel error={Boolean(error)}>{field.placeholder}</InputLabel>
            <OutlinedInput
                disabled={isDisabled}
                type={showPassword ? 'text' : 'password'}
                error={Boolean(error)}
                value={password} // content[field.id] || ''
                onChange={onPasswordControlChangeHandler}
                inputProps={{onBlur: onBlurHandler}}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                label={field.placeholder}
            />
            {!password && error && <FormHelperText error={Boolean(error)}>{error}</FormHelperText>}
        </FormControl>

        {<Collapse in={Boolean(password)}><div className='PasswordDuplicate'><FormControl fullWidth required={field.required} variant="outlined">
            <InputLabel error={Boolean(error)}>Введіть пароль повторно</InputLabel>
            <OutlinedInput
                error={Boolean(error)}
                disabled={isDisabled}
                type={showPassword ? 'text' : 'password'}
                value={passwordDublicate} // content[`${field.id}-dublicate`] || ''
                onChange={onPasswordDublicateControlChangeHandler}
                inputProps={{onBlur: onPasswordDublicateControlBlurHandler}}
                label='Введіть пароль повторно'
            />
            {password && error && <FormHelperText error={Boolean(error)}>{error}</FormHelperText>}
        </FormControl></div></Collapse>}
    </div>
}

// const isEmpty = (password, passwordDublicate) => {
//     if (!password && !passwordDublicate) return true;
//     return false;
// }

const hasEmpty = (password, passwordDublicate) => {
    if (!password || !passwordDublicate) return true;
    return false;
}

const getErrors = (password, passwordDublicate) => {
    if (password?.length > 0 && passwordDublicate?.length > 0) {
        if (password?.length < 6 ) {
            return 'Довжина пароля має бути більше 6 символів';
        }
        else if (password !== passwordDublicate) {
            return 'Паролі не співпадають';
        }
    }

    return null;
}
